// Fixed scope-tab navigation. Replaces the user-created template
// model from the original design: every user gets Overview / By
// Scorecard / By Agent / By Tag, and switching tabs swaps in that
// tab's saved layout + picker + widget visibility.
import React from 'react'

import { Menu } from '@/components/navigation/Menu'

import { SCOPE_TABS } from '../widgetRegistry'

export const DashboardTabs = ({ activeTab, onActivate }) => (
  <div className="dashboard-tab-header">
    <Menu
      menuStyle="bar"
      items={SCOPE_TABS.map((tab) => ({
        accessor: tab.key,
        label: tab.label,
        active: tab.key === activeTab,
        onClick: () => onActivate(tab.key),
        dataTestId: `dashboard-tab-${tab.key}`,
      }))}
    />
  </div>
)
